<div class="enkelleermiddelactivatieofgebruik">
  <canvas baseChart
          [data]="doughnutChartData"
          [chartType]="doughnutChartType"
          [colors]="doughnutChartColors"
          [options]="doughnutChartOptions"
          [plugins]="doughnutChartPlugins">
  </canvas>
</div>
